<div class="text-center mt-5">
    <h2>Updating...</h2>
    <p>Please wait while we are configuring new content.</p>
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>